import { demoConstants } from "@constants";

//View Demo Using Guest Account
export const atcViewDemoUsingGuestAccount = data => {
    return {
        type : demoConstants.VIEW_DEMO_GUEST_ACCOUNT_SUCCESS,
        payload: data
    };
};